import React, {useContext} from "react"
import {injectIntl} from "react-intl";
import ValidationTabBody from "../../commonui/mheValidation/ValidationTabBody";
import MHEValidationContextProvider from "../../mhevalidation/context/MHEValidationContext";
import {AsmlDeviceOverviewContext} from "./context/AsmlDeviceOverviewContext";

const VerificationCameraDeviceValidation = ({intl}) => {

    const {viewModel, dispatch} = useContext(AsmlDeviceOverviewContext);
    const deviceList = viewModel && viewModel.verificationCameraDeviceInformation ?
        Object.values(viewModel.verificationCameraDeviceInformation) : [];

    const props = {
        dispatch,
        deviceList,
        intl
    }

    return (<MHEValidationContextProvider><ValidationTabBody {...props}/></MHEValidationContextProvider> );
}

export default injectIntl(VerificationCameraDeviceValidation)


// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/VerificationCameraDeviceValidation.js